import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('PaginationAndSorting')
export class PaginationAndSorting {
  @JsonProperty('pageSize', Number, false) pageSize = 20;
  @JsonProperty('pageIndex', Number, false) pageIndex = 0;
  @JsonProperty('sortBy', String, false) sortBy = 'id';
  @JsonProperty('sortDirection', String, false) sortDirection = 'desc';
}
